<template>
	<div class="PCIndexPage">
		<div class="homePageContainer">
			<div class="header">
				<div class="logo">
							<img src="@/assets/img/leftIcon.png" alt="AI魔方 logo" />
						</div>
				<div class="navTabList">
					<div :class="{navTabItem: true, navTabItemActive: activeIndex === 0}" @click="goToPage(0)">AI魔方</div>
					<div :class="{navTabItem: true, navTabItemActive: activeIndex <= 2 && activeIndex > 0}" @click="goToPage(1)">浏览器</div>
					<div :class="{navTabItem: true, navTabItemActive: activeIndex === 3}" @click="goToPage(3)">输入法</div>
					<div :class="{navTabItem: true, navTabItemActive: activeIndex === 4}" @click="goToPage(4)">AI工位</div>
					<div :class="{navTabItem: true, navTabItemActive: activeIndex === 5}" @click="goToPage(5)">下载</div>
					<div :class="{navTabItem: true, navTabItemActive: activeIndex === 6}" @click="goToPage(6)">联系我们</div>
				</div>
			</div>
			<div class="CarouselContainer">
				<div ref="mySwiper" class="swiper">
					<div class="swiper-wrapper">
						<div class="swiper-slide">
							<div class="sliderPage">
								<div class="textBody">
									<div class="title">AI魔方<br />All in One的AI综合体</div>
									<div class="content">
										自动部署Deepseek/Qwen3大模型，立即拥有私有AI算力<br />
										自助整合各大AI并用，交叉验证，内容输出更优质，结果更满意 <br />
										自带本机知识库，消除AI幻觉，AI言之有物 <br />
										自定义Prompt工程，章节严丝合缝，多个AI帮你写作速成。
									</div>
								</div>
								<div class="imageBody">
										<img src="@/assets/img/firstPage.png" alt="AI魔方产品界面" style="width: 34rem" />
									</div>
							</div>
						</div>
						<div class="swiper-slide">
							<div class="sliderPage">
								<div class="textBody">
									<div class="title">让AI替你操作<br />定制AI Agent APP</div>
									<div class="content">
										开启：快捷打开软件⽂件<br />
										AI群：多个AI引擎同屏作答、取⻓补短<br />
										AI写作：AI辅助化整为零、多次蒸馏、⾼⾃由度<br />
										AI笔记：记录你的创意灵感与经验沉淀<br />
										收藏订阅：构建个⼈知识库、团队订阅与共享
									</div>
								</div>
								<div class="imageBody"><img v-lazy="'https://seaweedfs.thumpai.cn/4,03f50a268a9a.png'" alt="AI Agent功能展示" /></div>
							</div>
						</div>
						<div class="swiper-slide">
							<div class="sliderPage">
								<div class="imageBody"><img v-lazy="'https://seaweedfs.thumpai.cn/1,03f6a7703776.png'" alt="AI浏览器功能展示" /></div>
								<div class="textBody">
									<div class="title" style="margin-top: 20px">多个引擎，多种AI，纯净无广，一键直达</div>
									<div class="content">无广告;协同搜索本机、互联网的相关内容;多源数据、AI检索增强</div>
									<div class="content">不存储用户隐私数据；界面简约清爽，程序敏捷；</div>
									<div class="content">去除冗余功能，专注产品核心；页面简约清爽，输入极致体验；快捷操作，专注正事；</div>
								</div>
							</div>
						</div>
						<div class="swiper-slide">
							<div class="sliderPagePersonal">
								<div class="pageContentBody">
									<div class="pageContentItem">
										<div class="personalImage"><img src="@/assets/img/inputPage.png" alt="智能输入法功能展示" /></div>
									</div>
									<div class="pageContentItem">
										<div class="personalText">
											<div class="title">高效输入，知识管理<br />智能唤起AI</div>
											<div class="content">
												无缝切换:支持导入常用词库，延续输入习惯
												<br />
												ctrl c/v复合剪贴板:自动记忆，连续粘贴 <br />
												知识库语句调用:输入关键词迅速查看、调用、管理知识库中候选语句文章，实现一键上屏
												<br />AI智能唤起:AI即时响应作答，指令高度自定义
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="swiper-slide">
							<div class="sliderPageBox">
								<div class="sliderPage" style="top: 4vw">
									<div class="imageBody"><img v-lazy="'https://seaweedfs.thumpai.cn/1,03f7c4aa55c4.jpg'" alt="AI工位功能展示" /></div>
									<div class="textBody">
										<div class="title" style="margin-top: 20px">支持定制高性价比</div>
										<div class="content">
											自定Logo，彰显企业文化和归属感<br />
											独立部署，输入行为数据不泄露<br />
											单位文库，拟文引用规范，杜绝外部数据污染<br />
											PGC对接原有知识库，内外网全满足<br />
											UGC同步到单位文库
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="swiper-slide">
							<div class="sliderPageDownload">
								<div class="sliderPageDownloadItem">
									<div class="title">AI魔方立即体验</div>
									<div class="content">免费下载使用</div>
									<div class="button" style="background-color: dodgerblue" @click="goToPage(6)">
												<img src="https://seaweedfs.thumpai.cn/7,040514b663d4.png" alt="Windows版下载" />
												<span>Windows版</span>
											</div>
									<div class="button" style="background-color: rgb(90, 191, 222)" @click="goToPage(6)">
												<img src="https://seaweedfs.thumpai.cn/6,04061a6c9d42.png" alt="MAC版下载" />
												<span>MAC版</span>
											</div>
									<div class="button" style="background-color: rgb(91, 183, 91)" @click="goToPage(6)">
												<img src="https://seaweedfs.thumpai.cn/6,0407a9301550.png" alt="Linux统信版下载" />
												<span>Linux统信版</span>
											</div>
								</div>
								<div class="sliderPageDownloadItem">
											<img src="@/assets/img/download.png" alt="AI魔方下载页面" width="55%" />
										</div>
							</div>
						</div>
						<div class="swiper-slide">
							<div class="sliderPageUs sliderPage">
								<div class="imageBody">
										<img src="@/assets/img/endPage.png" alt="AI魔方联系方式" style="width: 30rem" />
									</div>
								<div class="textBody">
									<div class="title">联系方式</div>
									<div class="content">
										渠道合作：孟老师 13141200907
										<br />产品合作：尹老师 13811587758
										<!-- <a href="mailto: liuchao-cs@thupdi.com">yinweilin@thupdi.com</a> -->
										<br />联系地址：北京市海淀区中科大厦A座1204室
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="swiper-pagination"></div>
				</div>
			</div>
			<div class="downLoad" @click="goToPage(5)" v-show="activeIndex !== 5">立即下载</div>
			<div class="guide" v-show="activeIndex < 7" @click="goToPage(activeIndex + 1)">
					<img src="https://seaweedfs.thumpai.cn/5,03f8dd25c415.svg" alt="向下滚动指引" />
				</div>
			<div class="pageBottomBody" v-show="activeIndex === 6">
				<div class="footer">
					<p>备案序号：<a href="https://beian.miit.gov.cn" target="_blank">京ICP备17027715号-6</a></p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.css";

export default {
	name: "PCIndexPage",
	data() {
		return {
			currentSwiper: null,
			activeIndex: 0,
			resizeObserver: null
		};
	},
	mounted() {
		this.initSwiper();
		this.setupResizeObserver();
	},
	beforeDestroy() {
		if (this.resizeObserver) {
			this.resizeObserver.disconnect();
		}
	},
	methods: {
		initSwiper() {
			let currentIndex = 0;
			if (this.currentSwiper) {
				currentIndex = this.currentSwiper.activeIndex;
				this.currentSwiper.destroy(true, true);
			}
			let that = this;
			this.currentSwiper = new Swiper(".swiper", {
				speed: 400,
				spaceBetween: 0,
				direction: "vertical",
				mousewheel: true,
				pagination: {
					el: ".swiper-pagination",
					dynamicBullets: true,
					clickable: true,
				},
				on: {
					slideChangeTransitionEnd: function () {
						that.activeIndex = this.activeIndex;
					},
				},
			});
			this.currentSwiper.slideTo(currentIndex, 0, false);
		},
		goToPage(index) {
			this.activeIndex = index;
			this.currentSwiper.slideTo(index, 300, false);
		},
		setupResizeObserver() {
			let lastCall = 0;
			const handler = () => {
				const now = Date.now();
				if (now - lastCall >= 100) {  // 修改为100毫秒(0.1秒)
					this.initSwiper();
					lastCall = now;
				}
			};
			
			this.resizeObserver = new ResizeObserver(handler);
			this.resizeObserver.observe(document.documentElement);
		}
	},
};
</script>

<style lang="less">
@media (max-width: 1200px) {
	html {
		font-size: 12px;
	}
}

@media (min-width: 1200px) and (max-width: 1400px) {
	html {
		font-size: 14px;
	}
}

@media (min-width: 1400px) and (max-width: 1600px) {
	html {
		font-size: 16px;
	}
}

@media (min-width: 1600px) and (max-width: 1800px) {
	html {
		font-size: 18px;
	}
}
@media (min-width: 1800px) and (max-width: 2000px) {
	html {
		font-size: 20px;
	}
}
@media (min-width: 2000px) {
	html {
		font-size: calc(0.99vw);
	}
}

</style>

<style scoped lang="less">

.PCIndexPage {
	width: 100%;
	height: 100%;
	margin: 0 auto;
	box-sizing: border-box;
	background: #fff;
	font-family: 微软雅黑, serif;
	min-width: 1200px;

	.homePageContainer {
		width: 100%;
		height: 100%;
		overflow: hidden;
		position: relative;

		.header {
			width: 100%;
			height: 66px;
			padding: 10px 0;
			margin: 0 auto;
			background-color: white;
			top: 0;
			left: 0;
			box-sizing: border-box;
			position: absolute;
			z-index: 1100;
			display: flex;

			.logo {
				cursor: pointer;
				display: flex;
				width: 200px;
				height: 46px;
				line-height: 46px;
				padding-left: 20px;
				font-size: 24px;
				color: #424242;

				img {
					height: 46px;
					margin-right: 10px;
				}
			}

			.navTabList {
				flex: 1;
				line-height: 46px;

				.navTabItem {
					display: inline-block;
					width: 110px;
					text-align: center;
					font-size: 16px;
					cursor: pointer;
					user-select: none;
				}

				.navTabItem:hover {
					font-weight: bolder;
				}

				.navTabItemActive {
					color: dodgerblue;
				}
			}

			.rightLogo {
				height: 46px;
				display: flex;
				padding-right: 10px;

				img {
					flex: 1;
					display: block;
					height: 100%;
					margin: 0 5px;
					-webkit-filter: grayscale(100%);
					-o-filter: grayscale(100%);
					-moz-filter: grayscale(100%);
				}

				img:hover {
					-webkit-filter: grayscale(0);
					-o-filter: grayscale(0);
					-moz-filter: grayscale(0);
				}
			}
		}

		.CarouselContainer {
			width: 100%;
			height: 100%;
			padding-top: 66px;
			padding-bottom: 20px;
			box-sizing: border-box;

			.swiper {
				width: 100%;

				.swiper-wrapper {
					width: 100%;

					.swiper-slide {
						width: 100%;
						height: 100vh;
						background-color: rgb(251, 251, 251);
						position: relative;
					}
				}
			}

			.sliderPageBox {
				.title2 {
					font-size: 3rem;
					font-weight: bolder;
					line-height: 5rem;
					margin-bottom: 1rem;
					color: rgb(230, 0, 18);
					padding-left: 15rem;
				}
			}

			.sliderPage {
				width: 70rem;
				margin: 0 auto;
				position: absolute;
				top: 2rem;
				left: 15rem;
				display: flex;
				

				.textBody {
					color: rgb(85, 85, 85);
					padding: 20px 40px;
					box-sizing: border-box;

					.title1 {
						font-size: 3.4rem;
						font-weight: bolder;
						line-height: 6rem;
						margin-bottom: 2rem;
					}

					.title {
						font-size: 3rem;
						font-weight: bolder;
						line-height: 3.2rem;
						margin-bottom: 0.5rem;
						color: rgb(75, 73, 72);
					}

					.content {
						font-size: 1.1rem;
						line-height: 1.7rem;
						text-align: left;
						color: #868686;
						letter-spacing: 2px;

						span {
							font-size: 1.1rem;
						}
					}
				}

				.imageBody {
					margin-top: 1.8rem;

					img {
						width: 40rem;
						height: auto;
						border-radius: 10px;
					}
				}
			}

			.sliderPagePersonal {
				width: 70rem;
				margin: 0 auto;
				box-sizing: border-box;
				position: absolute;
				top: 1rem;
				left: 15rem;
				color: rgb(85, 85, 85);

				.title2 {
					font-size: 3rem;
					font-weight: bolder;
					line-height: 4rem;
					margin-bottom: 1rem;
					color: rgb(230, 0, 18);
					padding-left: 3rem;
				}

				.pageContentBody {
					width: 100%;
					display: flex;

					.pageContentItem {
						flex: 1;
						padding: 0 2rem;
						box-sizing: border-box;

						.personalImage {
							width: 90%;
							margin: 20px auto;

							img {
								width: 100%;
							}
						}

						.personalText {
							padding: 0 5%;

							.title {
								font-size: 3rem;
								font-weight: bolder;
								line-height: 4rem;
								margin-bottom: 2rem;
								color: rgb(75, 73, 72);
							}

							.content {
								font-size: 1.2rem;
								line-height: 1.8rem;
								text-align: left;
								color: #868686;
								letter-spacing: 2px;

								img {
									display: inline-block;
									width: 1.1rem;
									height: 1.1rem;
									box-sizing: border-box;
								}

								span {
									color: #c00000;
								}
							}
						}
					}
				}
			}

			.sliderPageDownload {
				width: 70rem;
				margin: 0 auto;
				padding-top: 30px;
				box-sizing: border-box;
				display: flex;
				position: absolute;
				top: 2rem;
				left: 15rem;

				.sliderPageDownloadItem {
					flex: 1;

					.title {
						font-size: 3rem;
						font-weight: bolder;
						line-height: 4rem;
						margin-bottom: 2rem;
						color: rgb(75, 73, 72);
					}

					.content {
						font-size: 1.2rem;
						line-height: 1.8rem;
						text-align: left;
						color: #868686;
						letter-spacing: 2px;
					}

					.button {
						width: 280px;
						height: 60px;
						border-radius: 4px;
						text-align: left;
						line-height: 60px;
						font-size: 1.1rem;
						cursor: pointer;
						user-select: none;
						color: white;
						margin: 40px 0;
						display: flex;
						padding: 0 6px;

						a {
							flex: 1;
							display: inline-block;
							height: 100%;
							color: white;
							text-decoration: none;
						}

						a:hover {
							text-decoration: none;
						}
					}
				}
			}
		}

		.downLoad {
			width: 210px;
			height: 50px;
			position: fixed;
			left: calc(50% - 105px);
			top: 85%;
			border-radius: 5px;
			line-height: 50px;
			font-size: 20px;
			background: red;
			text-align: center;
			z-index: 1100;
			color: #ffffff;
			user-select: none;
		}

		.guide {
			position: fixed;
			bottom: 6%;
			left: 50%;
			opacity: 1;
			margin-left: -32px;
			z-index: 1100;
			-webkit-animation: guide 2.5s infinite;
		}

		@keyframes guide {
			0% {
				bottom: 6%;
			}
			50% {
				bottom: 3%;
			}
			100% {
				bottom: 6%;
			}
		}

		.pageBottomBody {
			width: 100%;
			height: 24px;
			bottom: 0;
			left: 0;
			box-sizing: border-box;
			position: absolute;
			line-height: 24px;
			color: #282828;
			text-align: center;
			background-color: #fff;
			clear: both;
			overflow: hidden;
			z-index: 1100;

			a {
				color: #282828;
				padding: 0 10px;
				text-decoration: none;
			}
		}
	}
}
</style>
